import React, { useState } from 'react';
import { Alert, Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { LoyaltyService } from '../../../api/LoyaltyService';
import { findLang } from '../../models/lang';
import { EXTERNAL_LINKS } from '../../../constants';

const AgbConsentModal = ({ open, onAccepted }) => {
    const { t, i18n } = useTranslation();
    const [saving, setSaving] = useState(false);
    const [failed, setFailed] = useState(false);

    const handleAccept = async () => {
        setFailed(false);
        setSaving(true);
        try {
            await LoyaltyService.acceptAgb();
            onAccepted();
        } catch {
            // The dialog is non-dismissible (SoT §7), so a silent failure would trap the
            // user with no feedback — surface it and let them retry.
            setFailed(true);
        } finally {
            setSaving(false);
        }
    };

    return (
        <Dialog open={open} disableEscapeKeyDown maxWidth="sm" fullWidth>
            <DialogTitle>{t('loyalty.consent.title')}</DialogTitle>
            <DialogContent>
                <Typography>{t('loyalty.consent.body1')}</Typography>
                <Typography sx={{ mt: 1.5 }}>{t('loyalty.consent.body2')}</Typography>
                <Typography sx={{ mt: 1.5 }}>{t('loyalty.consent.body3')}</Typography>
                <Typography
                    sx={{ mt: 1.5, display: 'inline-block' }}
                    component="a"
                    color="primary.main"
                    href={EXTERNAL_LINKS[findLang(i18n.language).i18nCode].terms}
                    rel="noopener noreferrer"
                    target="_blank"
                >
                    {t('loyalty.consent.termsLink')}
                </Typography>
                {failed && (
                    <Alert severity="error" sx={{ mt: 2 }}>
                        {t('loyalty.consent.error')}
                    </Alert>
                )}
            </DialogContent>
            <DialogActions sx={{ px: 3 }}>
                <Button variant="contained" color="primary" disabled={saving} onClick={handleAccept}>
                    {t('loyalty.consent.accept')}
                </Button>
            </DialogActions>
            <Typography variant="caption" color="text.secondary" sx={{ display: 'block', px: 3, pb: 2.5 }}>
                {t('loyalty.consent.footer')}
            </Typography>
        </Dialog>
    );
};

export default AgbConsentModal;
